import { BaseApi } from './base.api.js';

export class GovernanceReportDefinitionApi extends BaseApi {
    constructor(client) {
        super(client, '/governance-report-definition');
    }
}
